import React, { useState, useEffect, memo } from "react";

import { useDispatch, useSelector } from 'react-redux';
import { Link } from "react-router-dom";
import MUIDataTable from "mui-datatables";
import {Tooltip,Chip,Typography,useTheme,Box,IconButton} from "@material-ui/core";
import { saveAs } from 'file-saver';
import { MuiThemeProvider } from "@material-ui/core/styles";
import useStyles from "./styles";
import { getMuiTheme } from "./styles";
// import { Options } from "./options";
import { formatDate } from "../../../../common/utils";
// import NumberFormat from 'react-number-format';
import VisibilityIcon from '@material-ui/icons/Visibility';
import SkeletonShell from "../../../Skeleton";
import CloseIcon from '@material-ui/icons/Close';
import EditIcon from '@material-ui/icons/Edit';
import { pathOr } from 'ramda';
import {
  getDashlet
} from "../../../../store/actions/dashboard.actions";
import { closeActivity } from "../../../../store/actions/subpanel.actions";

import {NoRecord,Alert } from "../../../../components";
import { toast } from "react-toastify";
import FileViewerComp from "../../../FileViewer/FileViewer";
import { configureDashlet } from "../../../../store/actions/dashboard.actions";
import { getCalculations } from '../../../../common/policyCalculation';


const DashletList = ({ module, tableData, currentTab, title = '', titleKey = '', dashlet_id = '',fullData=[],isDashletUpdated=[], allTabFilter=[] , setConfiguredDashlet,setIsDashletUpdated,setValue}) => {
 const { dashletLoading } = useSelector((state) => state.dashboard);
  const config = useSelector((state) => state.config);
  const [alertVisible, setAlertVisibility] = useState(false);
  const [activityRecord, setActivityRecord] = useState("");
  // const [dashId, setDashId] = useState(pathOr('', ['id'], fullData));
	const [showLoading,setShowLoading]= useState(false);
  const {  configureDashletLoading } = useSelector(
    (state) => state.dashboard,
  );
  
  const [responsive] = useState("standard");
  const [tableBodyHeight] = useState("100%");
  const [tableBodyMaxHeight] = useState("");
  // console.log('fullData', allTabFilter);

  const callbackMethod = pathOr(false, ["data", "data","callbackMethod"], fullData);
  let customizeTableData = false;
  if(callbackMethod){
    switch (callbackMethod) {
      case 'getYourTransaction':
        let summaryOfTransactions = pathOr([], ["data", "data","summaryOfTransactions"], fullData);
        let columnToCalculate = pathOr([], ["data", "data","columnToCalculate"], fullData);
        customizeTableData = getCalculations(callbackMethod, {tableData, summaryOfTransactions, columnToCalculate});
        break;
      
      case 'getPolicyAllocationTable':
        // console.log(fullData);
        customizeTableData = getCalculations(callbackMethod, tableData.data);
        // tableData.data = tableAllocationData;
        break;

      default:
        break;
    }
  }

  const isPaginate= pathOr(true, ["data", "data","paginate"], fullData);
  const [page, setPage] = useState(0);
  const [reportId, setReportId] = useState(null);
  const site_url = pathOr("", ["config", "site_url"], config);
  const [totalRecords, setTotalRecords] = useState(0);

  const [columns, setColumns] = useState([]);
  const [highliteRow, setHighliteRow] = useState(null);
  // const [dashletType, setDashletType] = useState(pathOr('', ['subType'], fullData));
  const [data, setData] = useState([]);
  //const [module, setModule] = useState(module);
  const [rowsPerPage, setRowsPerPage] = useState(pathOr(5, ['config','list_max_entries_per_subpanel'], config));

  const classes = useStyles();
  const currentTheme = useTheme();
  const dateFormat = pathOr(undefined, ['config', 'datef'], config);
  const dispatch = useDispatch();
  const [previewFile, setPreviewFile] = useState({open:false,filename:"",filepath:""});

  const isLink=pathOr(pathOr([], ['data', 'data','query',0,'link'], fullData), ['data', 'data','link'], fullData);
  const  handleShowPreviewFile = (fname,url) =>{
    let arr = fname.split(".");
    let ext = arr[arr.length-1].toUpperCase();
    setPreviewFile({open:true,filename:fname,filepath:url,filetype:ext});
  } 

  function truncate(str,n) {
    return str?.length > n ? str.substr(0,n-1) + "..." : str;
  }
const redirectOnFilter=(redirectData)=>{
console.log("redirectData",redirectData,isLink,fullData)
const getRedirectData=pathOr(pathOr([], ['data',pathOr(pathOr('', ['name'], isLink), ['redirectName'], isLink)], redirectData), [pathOr(pathOr('', ['name'], isLink), ['redirectName'], isLink)], redirectData)
const isSingle=pathOr(false, ['single'], isLink)?getRedirectData:[getRedirectData];
    let redirectFieldsArray=[{name:pathOr('', ['redirectFields',0], isLink),value:isSingle}]
  //   pathOr([], ['redirectFields'], dataList).map((rRow)=>{
  //     redirectFieldsArray.push({name:rRow,value:redirectData[rRow]})
  //   })
  //   // console.log(dataList.redirectOn,redirectData,...redirectFieldsArray)
    let redirectDestructData=[redirectFieldsArray]
    const params = {
      "configureDashlet": {
          "id": pathOr('', ['redirectDashlet'], isLink),
          "module": "HomeApp",
          "configure": "true",
          "redirected": "true",
          'type': 'custom',
          'data': {data:pathOr([], [0], redirectDestructData)},
          'currentTab': pathOr('', ['redirectOn'], isLink),
          'dashlets': []
      }

  };
  try {
      dispatch(configureDashlet(params)).then(function (res) {
          if (res.data.status === 200) {
                  toast('Dashlet Updated Successfully!')
                  setValue(isLink.redirectOn)
          } else {
              toast('Something went wrong!');

          }
      });
  } catch (e) {
      toast('Something went wrong!');
  }
}
  const statusBackground = pathOr([],["config", "fields_background", module],config);
  
  let statusField = Object.keys(statusBackground);
  useEffect(() => {
    setRowsPerPage(tableData.module === 'AOR_Reports' ? 20 : pathOr(5, ['data','data','size'], fullData))
    setColumns(pathOr([], ['datalabels'], tableData))
    setData(customizeTableData ? customizeTableData : pathOr([], ['data'], tableData))
    setTotalRecords(parseInt(pathOr(pathOr(0, ['totalrecords'], tableData), ['totalRecords'], tableData)))
    // setShowLoading(isDashletUpdated.indexOf(dashId) !== -1);
    const resultHlRow = pathOr([], ['data'], tableData).findIndex(element=> element.type == 'Parent');
    setHighliteRow(resultHlRow);    
    
  }, [tableData])

  useEffect(()=>{
      setPage(pathOr(0, ['data','data','page'], fullData))
  },[fullData])
  
 
  const confirmCloseActivity = (module, relateId) => {
    setAlertVisibility(true);
    setActivityRecord({ module: module, status: module === 'Tasks' ? 'Completed' : 'Held', relateId: relateId });
  };
  const closeActivityMethod = async () => {
    setAlertVisibility(!alertVisible);
    try {
      var submitData = {
        data: {
          type: activityRecord.module,
          id: activityRecord.relateId,
          attributes: { 'status': activityRecord.status },
        }
      };
      let data = JSON.stringify(submitData);
      const res = await closeActivity(data);
      if (res.data.data.id) {
        changePageOrSort(page);
        toast('It was successfully closed!');
      
      }
    } catch (e) {
      toast("Something went wrong!");
    }
  };

  // console.log('rowsPerPage',parseInt(rowsPerPage))
  const options = {
    responsive,
    tableBodyHeight,
    tableBodyMaxHeight,
    filter: false,
    download: false,
    serverSide: true,
    count: parseInt(totalRecords),
    rowsPerPage: parseInt(rowsPerPage),
    page,
    fixedHeader: true,
    fixedSelectColumn: true,
    search: false,
    print: false,
    viewColumns: false,
    selectableRowsHeader: false,
    rowsPerPageOptions: [parseInt(rowsPerPage)],
    selectableRows: 'none',
    pagination:isPaginate,
    setRowProps: (row,rowKey) => { 
    
      if (highliteRow===rowKey) {
        return {
          style: { background: "#CCCCCC" }
        };
      }
    },
    textLabels: {
      body: {
        noMatch: <NoRecord 
        view = 'dashlet_no_data' 
        subpanel_module=''
        module=''
      />,

      },
    },
    onTableChange: (action, tableState) => {
      // console.log('onTableChange',action,tableData,fullData,tableState)
      switch (action) {
        case "changePage":
          if (tableState.sortOrder.hasOwnProperty("name")) {
            // let directionToSort =
            //   tableState.sortOrder.direction === "desc"
            //     ? `-${tableState.sortOrder.name}`
            //     : tableState.sortOrder.name;
            changePageOrSort(tableState.page, tableState.sortOrder.name, tableState.sortOrder.direction);
            break;
          }
          changePageOrSort(tableState.page);
          // handlePageChange(tableState)
          break;
        case "sort":
          // if (tableState.sortOrder.direction === "desc") {
          changePageOrSort(
            tableState.page, tableState.sortOrder.name, tableState.sortOrder.direction
          );
          break;
          // }
          changePageOrSort(tableState.page, tableState.sortOrder.name);

          break;
        default:
        // console.log(action + "action not handled.");
      }

    },
  };


  const changePageOrSort = (page, sortBy = null, sortOrder = null) => {

   
    if(pathOr('',['subType'],fullData)==='Table List')
    {
      try {
        const params = {
                "configureDashlet": {
                    "id": pathOr('',['id'],fullData),
                    "module": "HomeApp",
                    "configure": "true",
                    "redirected": "true",
                    'type': 'custom',
                    'data': {data:pathOr([], ['data','data'], fullData)},
                    'currentTab': currentTab,
                    'dashlets': [],
                    'tableListData':{page,sortBy,sortOrder}
                }
        
            };
            setIsDashletUpdated([pathOr('',['id'],fullData)]);
            setPage(page)
            // console.log('tablechange',fullData,params)
            try {
                dispatch(configureDashlet(params)).then(function (res) {
                    if (pathOr(false,['data','status'],res) === 200) {
                         setData(pathOr([], ['data','result','data','data'], res.data))
                         const resultHlRow = pathOr([], ['data','result','data','data'], res.data).findIndex(element=> element.type == 'Parent');
   setHighliteRow(resultHlRow);
                            // toast('Dashlet Updated Successfully!')
                            setIsDashletUpdated([]);
                      } else {
                        toast('Something went wrong!');
                 }
                });
            } catch (e) {
                toast('Something went wrong!');
        
            }
        
        
             
            } catch (e) {
              toast('Something went wrong!');
            }
    }
    else{
    setPage(page)
    setReportId(titleKey)
    // console.log("sortBy", sortBy);
    let offset = page * rowsPerPage;
    const params = { 'tab': currentTab, 'sortBy': sortBy, 'sortOrder': sortOrder, 'offset': offset, 'dashlet_id': dashlet_id, 'group_value': titleKey };
    try {
      dispatch(getDashlet(params)).then(function (res) {
        if (res.ok) {

          let dashListData = pathOr([], ['data', 'data', 'dashlets', 0, 'data', 'data'], res);
          if (module === 'AOR_Reports') {
            let isGroup = parseInt(pathOr(false, ['report_data', 'is_group_data'], dashListData));
            if (isGroup) {
              // dashListData = pathOr([], ['report_data', 'group_outer_block'], dashListData);
              dashListData = pathOr([], ['report_data', 'group_outer_block', 'group_data', 'data'], dashListData);
            } else {
              dashListData = pathOr([], ['report_data', 'group_outer_block', 'group_data', 'data'], dashListData);
            }
          } else {
            dashListData = pathOr([], ['data'], dashListData);

          }
          // console.log(dashListData)
          setData(dashListData)
          // toast('Dashlet Removed Successfully!');
        } else {
          toast('Something went wrong!');
        }
      });
    } catch (e) {
      toast('Something went wrong!');
    }
    setReportId(null)
    }
  }
// console.log("columns",columns)

  const getFilteredDataLabels = () => {
    return [

      ...columns
        .filter((it) => it.name)
        .map((dl) => {
          if (statusField && statusField.length > 0 && statusField.some(item => dl.name === item)) {
            return {
              ...dl,
              options: {
                filter: false,
                sort:false,
                customBodyRender: (value, tableMeta, updateValue) => {
                  let option = (dl.options) ? Object.keys(dl.options).find(key => dl.options[key] === value) : value;
                  let optionBgColor = `${pathOr("", [dl.name, option, "background_color"], statusBackground)}`;
                  let statusStyle = {};

                  if (currentTheme.palette.type === 'dark') {
                    statusStyle = { color: optionBgColor, fontWeight: 'bolder', background: 'transparent', border: '1px solid' };

                  } else {
                    statusStyle = { color: optionBgColor, background: optionBgColor + "20", border: 'none', };
                  }
                  
                  return (
                    value && optionBgColor ? <Chip size="small" className={classes.statusBg} style={statusStyle} label={value} /> : value
                  )
                }
              }
            }
          }
          if(dl.name==='document_name')
          {
            return {
              ...dl,
              options: {
                filter: false,
                sort: false,
                customBodyRender: (value, tableMeta, updateValue) => {
                  const id = module === 'AOR_Reports' ?data[tableMeta["rowIndex"]]['attributes'].id || '': data[tableMeta["rowIndex"]].id;
                  return (
                    <Typography>
                     {id!=='' ? <Link
                        to={`/app/detailview/${module}/${id}`}
                        className={classes.link}
                        // component="button"
                        variant="body2"
                      >
                        {value}
                      </Link>:value}
                    </Typography>
                  );
                },
              },
            };
          }
          if(dl.type==="file" )
          {
            return {
              ...dl,
              options: {
                filter: false,
                sort: false,
                customBodyRender: (value, tableMeta, updateValue) => {
                  
                  let furl = `${site_url}/index.php?entryPoint=customDownload&id=${data[tableMeta["rowIndex"]].id}&type=${module}`;
                  return (
                    value ?
                    <Typography>
                      <VisibilityIcon fontSize='small' style={{margin:"-1vh",marginLeft:"1vh",marginRight:"1vw",cursor:"pointer"}}    onClick={()=>handleShowPreviewFile(value,furl)} />
                      <Tooltip title={value}>
                        <Link to={`#`} className={classes.link} onClick={() => {saveAs(furl, data[tableMeta["rowIndex"]].filename);toast("Downloading in progress!");}} variant="body2">
                          {truncate(value,20) || truncate(data[tableMeta["rowIndex"]].document_name,20) || ""}
                        </Link>
                      </Tooltip>                    
                    </Typography>
                    : "" 
                  );
                },
              },
            };
          }
          // if (dl.name === "name") {
          //   return {
          //     ...dl,
          //     options: {
          //       filter: false,
          //       sort: (module === 'AOR_Reports' ? false : true),
          //       customBodyRender: (value, tableMeta, updateValue) => {
          //         const id = module === 'AOR_Reports' ?data[tableMeta["rowIndex"]]['attributes'].id || '': data[tableMeta["rowIndex"]].id;
                  
          //         return (module === 'AOR_Reports' && dl.link=='1')?<Link to={`/app/detailview/${value.module}/${value.id}`} className={classes.link} variant="body2">
          //                 {value.value}
          //               </Link>:<Typography>
          //            {id!=='' ? <Link to={`/app/detailview/${module}/${id}`} className={classes.link} variant="body2">{value}</Link>:value}
          //           </Typography>;
          //       },
          //     },
          //   };
          // }
          // else
           if (dl.type === "relate") {
            return {
              ...dl,
              options: {
                filter: false,
                customBodyRender: (value, tableMeta, updateValue) => {
                  const ss = dl.id_name;
                  const parent_id = data[tableMeta["rowIndex"]][ss];
                  const parent_type = dl.module;
                  return (module === 'AOR_Reports' && dl.link=='1')?<Link to={`/app/detailview/${value.module}/${value.id}`} className={classes.link} variant="body2">
                          {value.value}
                        </Link>:<Typography>
                      <Link to={`/app/detailview/${parent_type}/${parent_id}`} className={classes.link} variant="body2">{value}</Link>
                    </Typography>;
                },
              },
            };
          }
          else if (dl.type === "parent") {
            return {
              ...dl,
              options: {
                filter: false,
                customBodyRender: (value, tableMeta, updateValue) => {
                  const parent_id = data[tableMeta["rowIndex"]].parent_id;
                  const parent_type = data[tableMeta["rowIndex"]].parent_type;
                  return (module === 'AOR_Reports' && dl.link=='1')?<Link to={`/app/detailview/${value.module}/${value.id}`} className={classes.link} variant="body2">
                          {value.value}
                        </Link>:<Typography>
                      <Link to={`/app/detailview/${parent_type}/${parent_id}`} className={classes.link} variant="body2">{value}</Link>
                    </Typography>;

                },
              },
            };
          }
          else if (
            dl.type === "date" ||
            dl.type === "datetime" ||
            dl.type === "datetimecombo"
          ) {
            return {
              ...dl,
              options: {
                customBodyRender: (value, tableMeta, updateValue) =>
                (module === 'AOR_Reports' && dl.link=='1')?
                <Link 
                  to={`/app/detailview/${value.module}/${value.id}`}
                  className={classes.link} 
                  variant="body2"
                  >
                    formatDate(value.value, dateFormat)
                </Link>
                :formatDate(value, dateFormat),
                sort: (module === 'AOR_Reports' ? false : false),
              },
            };
          }
          // 10/04/2023: Added condition as per AXA request to show upto 4 digits after decimal place for unit price and units held
          
          else if( dl.type === "decimal" && (dl.key === "unitprice" || dl.key === "totalunits"))
          {
            return {
              ...dl,
              options: {             
                customBodyRender: (value, tableMeta, updateValue) => 
                (module === 'AOR_Reports' && dl.link=='1') ?              
                  <Link to={`/app/detailview/${value.module}/${value.id}`} className={classes.link}
       variant="body2">
                    {getCalculations('getValueOnlyInDecimal', value.value)}                    
                  </Link>
                  :
                  <> 
                    {getCalculations('getUnitPriceInDecimal', value)}
                  </>,
                sort: (module === 'AOR_Reports' ? false : false),
              },
            };
          }
          else if (dl.type === "decimal") 
          // dl.type === "currency" ||
            {
            return {
              ...dl,
              options: {
             
                customBodyRender: (value, tableMeta, updateValue) =>
                 (module === 'AOR_Reports' && dl.link=='1') ?
                 <Link to={`/app/detailview/${value.module}/${value.id}`} className={classes.link} variant="body2">
                   {getCalculations('getValueOnlyInDecimal', value.value)}
                          {/* <NumberFormat value={value.value} displayType={'text'} thousandSeparator={true} decimalSeparator="." decimalScale={2} /> */}
                  </Link>
                  :<> 
                        {getCalculations('getValueOnlyInDecimal', value)}
                        {/* <NumberFormat value={value} displayType={'text'} thousandSeparator={true} decimalSeparator="." decimalScale={2} /> */}
                   </>,
                sort: (module === 'AOR_Reports' ? false : false),
              },
            };
          }
          else if (
          
            dl.type === "return"
          ) {
            return {
              ...dl,
              options: {
             
                customBodyRender: (value, tableMeta, updateValue) =>
                 (module === 'AOR_Reports' && dl.link=='1')?<Link to={`/app/detailview/${value.module}/${value.id}`} className={classes.link} variant="body2">
                   {getCalculations('getValueOnlyInDecimalAndPercent', value.value)}
                          {/* <NumberFormat value={value.value} displayType={'text'} thousandSeparator={true} decimalSeparator="." decimalScale={2} /> */}
                        </Link>:<> 
                        {getCalculations('getValueOnlyInDecimalAndPercent', value)}
                        {/* <NumberFormat value={value} displayType={'text'} thousandSeparator={true} decimalSeparator="." decimalScale={2} /> */}
                        </>,
                sort: (module === 'AOR_Reports' ? false : false),
              },
            };
          }

          else if (dl.name === "action_c") {
            return {
              ...dl,
              options: {
                customBodyRenderLite: (dataIndex, rowIndex) => (

                  <IconButton aria-label="delete" className={classes.margin} size="small" onClick={() => alert("Edit")} >
                    <EditIcon fontSize="inherit" />
                  </IconButton >
                ),
                sort: (module === 'AOR_Reports' ? false : false),
              },
            };
          }
          else if (dl.name === "set_complete") {
     
            return {
              ...dl,
              options: {
                sort: false,
                  customBodyRender: (value, tableMeta, updateValue) =>{
                    const id =  data[tableMeta["rowIndex"]].id;
                 return ((module==='Calls' && data[tableMeta["rowIndex"]].status !=='Held' )||( module==='Meetings' && value !=='Held') ||( module==='Tasks' && value !=='Completed')) ?<IconButton aria-label="delete" className={classes.margin} size="small"  onClick={() => confirmCloseActivity(module, id)}>
                    <CloseIcon fontSize="inherit" />
                  </IconButton>:null;
                  
              }
              }
            }
          }
          else if (dl.name === 'assigned_user_id') {
            return {
              ...dl,
              options: {
                sort: false,
              },
            }
          }else if(dl.type === "redirectLink"){
            return {
              ...dl,
              options: {
                sort: (false),
                customBodyRender: (value, tableMeta, updateValue) => {
                  return highliteRow!==tableMeta["rowIndex"]?value?<Link  to={`#`} 
                   onClick={()=>redirectOnFilter(data[tableMeta["rowIndex"]])} className={classes.link} variant="body2">
                          {value}
                        </Link>:null:value
                },
              },
            }
          }
          else {
            return {
              ...dl,
              options: {
                sort: (module === 'AOR_Reports' ? false : false),
                customBodyRender: (value, tableMeta, updateValue) => {
                  return (module === 'AOR_Reports' && dl.link=='1')?<Link to={`/app/detailview/${value.module}/${value.id}`} className={classes.link} variant="body2">
                          {value.value}
                        </Link>:value;
                },
              },
            }
          }
        }),
    ];
  };

  const getFilteredData = () => data && data.map((item,itemKey) => {
    const row = {};
  
  let rowData=pathOr(item, ['data'], item);
  
  
      if (tableData.module === "AOR_Reports") {
      Object.keys(rowData.attributes).map((key) => {
        row[key] = rowData.attributes[key];
      })
    } else {
      columns.map((col) => {
        row[col.name] = rowData[col.name];
      })
    }
  
    return row;
  });



  return (
    <>
      <Box className={classes.overlay}  display={dashletLoading[dashlet_id] ? 'block' : 'none'}>
        <SkeletonShell layout='listView' display />
        {/* <CircularProgress color="inherit" /> */}
      </Box>
      {/* <Box display={!dashletLoading[dashlet_id]?'block':'none'}> */}
      <>
      { fullData.isSubHeader?
         <Typography className={classes.axaLabel} >
        {fullData.label}
      </Typography>
  :null}
        { (configureDashletLoading && !isDashletUpdated.length) || (showLoading) || (configureDashletLoading && isDashletUpdated.includes(pathOr('',['id'],fullData))) ?<SkeletonShell layout="table" />:
         <MuiThemeProvider theme={getMuiTheme(currentTheme)}>
              <Alert
        title="Close"
        msg="Do you want to close this?"
        open={alertVisible}
        agreeText={"Yes"}
        disagreeText={"No"}
        handleClose={() => setAlertVisibility(!alertVisible)}
        onAgree={closeActivityMethod}
      />
            <MUIDataTable
              title={title ? title : ""}
              data={getFilteredData()}
              columns={getFilteredDataLabels()}
              options={options}
             
             

            />
          </MuiThemeProvider> 
        //   : 
        //   <NoRecord 
        //   view = 'dashlet_no_data' 
        //   subpanel_module=''
        //   module=''
        // />
        
          }
          {(previewFile.open) ? <FileViewerComp previewFile={previewFile} setPreviewFile={setPreviewFile} /> : ""}
      </>
      {/* </Box> */}
    </>
  );
};

export default memo(DashletList);
